import React, {useCallback, useEffect, useState} from "react";
import {DateTime} from "luxon";
import {getNotBelowZero} from "modules/utils/helpers";

interface IProps {
	date: string;
	onTick?: (timeToEnd: number) => void;
	onComplete?: () => void;
	render?: boolean;
	ref?: React.Ref<HTMLSpanElement>;
	paused?: boolean;
}

export const Timer: React.FC<IProps> = ({
	date,
	onTick,
	onComplete,
	render = true,
	ref,
	paused = false,
}) => {
	const [duration, setDuration] = useState(0);

	const calcDiff = useCallback(() => {
		const startDate = DateTime.fromJSDate(new Date());
		const endDate = DateTime.fromJSDate(new Date(date));
		const diff = endDate.diff(startDate).get("milliseconds");

		if (onTick && typeof onTick === "function") {
			onTick(diff);
		}

		if (onComplete && typeof onComplete === "function" && diff <= 0) {
			onComplete();
		}

		return diff;
	}, [date, onTick, onComplete]);

	const clearIntervalHandler = useCallback((interval: NodeJS.Timer) => {
		clearInterval(interval ?? undefined);
	}, []);

	useEffect(() => {
		const interval = setInterval(() => {
			const diff = calcDiff();
			setDuration(diff);

			if (diff <= 0) {
				clearIntervalHandler(interval);
			}
		}, 333);

		return () => {
			clearIntervalHandler(interval);
		};
	}, [calcDiff, clearIntervalHandler]);

	if (!render) {
		return null;
	}

	const timeToEnd = getNotBelowZero(duration);
	const renderedTime = Math.floor((timeToEnd + 900) / 1000);

	return (
		<span ref={ref} className="renderer-timer-time">
			{renderedTime}
		</span>
	);
};
